export default <T extends HTMLElement = HTMLElement>(string: string): T => {
  const template = document.createElement('template');
  template.innerHTML = string.trim();

  if (!(template.content.firstChild instanceof HTMLElement)) {
    throw new TypeError('The passed string was invalid. The first content must be a HTML tag');
  }

  return <T>template.content.firstChild;
};
